import * as React from 'react';
// import classNames from 'classnames';
import { TwitterTimelineEmbed } from 'react-twitter-embed';
import TrendingResearchContainer from 'buyside/components/container/Trending/TrendingResearchContainer';
import Button, {
  BUTTON_TYPES,
  BUTTON_SIZES,
  BUTTON_WIDTHS
} from 'buyside/components/presentation/Button/button';

import PencilIcon from 'buyside/svgs/pencil.svg';
import LightBulbIcon from 'buyside/svgs/lightbulb.svg';
import BellIcon from 'buyside/svgs/bell.svg';
import UserIcon from 'buyside/svgs/user_icon.svg';

import {
  newResearchUrl,
  inviteMembersUrl,
  onboardingUrl,
  userWatchlistUrl
} from 'buyside/util/urlHelper';

import styles from './rightSidebarStyles.scss';

export type IProps = {
  canViewUserDetails: boolean;
  canWriteIdeas: boolean;
  canWriteWhitePapers: boolean;
};

const RightSidebar: React.FunctionComponent<IProps> = ({
  canViewUserDetails,
  canWriteIdeas,
  canWriteWhitePapers
}): React.ReactElement => (
  <aside>
    <div className={styles.rightSidebarButtons}>
      {(canWriteIdeas || canWriteWhitePapers) && (
        <Button
          text="Submit Research"
          type={BUTTON_TYPES.MAJOR}
          size={BUTTON_SIZES.MEDIUM}
          icon={PencilIcon}
          url={newResearchUrl()}
          width={BUTTON_WIDTHS.FULL}
          analyticsTag="submit-research"
        />
      )}
      <Button
        type={BUTTON_TYPES.PRIMARY}
        width={BUTTON_WIDTHS.FULL}
        icon={LightBulbIcon}
        className={styles.watchlistButton}
        url={userWatchlistUrl()}
        text="Update Your Watchlist"
      />
      <Button
        type={BUTTON_TYPES.PRIMARY}
        size={BUTTON_SIZES.MEDIUM}
        width={BUTTON_WIDTHS.FULL}
        text="Adjust Your Activity Feed"
        url={onboardingUrl()}
        analyticsTag="adjust-feed"
        icon={BellIcon}
      />
      <Button
        type={BUTTON_TYPES.PRIMARY}
        size={BUTTON_SIZES.MEDIUM}
        width={BUTTON_WIDTHS.FULL}
        text="Invite New Members"
        url={inviteMembersUrl()}
        analyticsTag="invite-new-members"
        icon={UserIcon}
      />
    </div>
    <TrendingResearchContainer showUserDetails={canViewUserDetails} />
    <div className={styles.twitterTimelineContainer}>
      <TwitterTimelineEmbed
        sourceType="profile"
        screenName="SumZero"
        options={{ height: 600 }}
        noBorders
      />
    </div>
  </aside>
);

export default RightSidebar;
